import ExemptionModal from './ExemptionModal';

export default ExemptionModal;
